<template lang="pug">
section.attachment-input
  .user-attachments
    .button-group
      button.tag(
        @click="toggleAttachment('ACTIVITY')"
        :class="{ active: attachmentType === 'ACTIVITY' }")
        | Activity
      button.tag(
        @click="toggleAttachment('INTERNAL_LINK')"
        :class="{ active: attachmentType === 'INTERNAL_LINK' }")
        | Internal
      button.tag(
        @click="toggleAttachment('EXTERNAL_LINK')"
        :class="{ active: attachmentType === 'EXTERNAL_LINK' }")
        | External
      button.tag(
        @click="toggleAttachment('EXTERNAL_LINK_PHONE')"
        :class="{ active: attachmentType === 'EXTERNAL_LINK_PHONE' }")
        | Phone Number
    template(v-if="attachmentType !== null")
      .compose-message-add-link
        template(v-if="attachmentType === 'INTERNAL_LINK'")
          coaching-message-internal-link-input(
            @internal-message-valid="addInternalLinkAttachment"
            @internal-message-invalid="setCanAddAttachment(false)")
        template(v-if="attachmentType !== 'INTERNAL_LINK'")
          input.title(
            v-if="attachmentType === 'EXTERNAL_LINK'"
            type="text"
            placeholder="Input a external link title"
            v-model="externalLinkTitle"
            ref="attachmentTitleInput")
          input.link(
            type="text"
            :placeholder="attachmentInputPlaceholder"
            v-model="attachmentUrl"
            ref="attachmentInput")
          button.cancel(
            title="Clear attachment input"
            @click="toggleAttachment(attachmentType)")
            span.close-icon &#43;
          template(v-if="attachmentType === 'ACTIVITY'")
            div.tooltip-wrapper
              span.has-tooltip.link-highlight(@click="toggleActivityToolTip()")
                | How do I find the identifier?
              transition(name="fade")
                .activity-tooltip-content.tooltip-content(
                  v-if="showActivityToolTip"
                  @mouseleave="setShowActivityToolTip(false)")
                  section.tooltip-body
                    strong For Activity:
                    ul
                      li Identifier can be found from the activity URL in app
                      li Example:
                        br
                        a(href="https://app.mystrength.com/v/activity/be_open_to_new_eyes/intro"
                        target="_blank")
                          | https://app.mystrength.com/v/activity/
                          strong be_open_to_new_eyes
                          |/intro
                      li The identifier for this activity is the part right after activity/ and before /intro in the URL :&nbsp;
                        strong be_open_to_new_eyes

      button.btn.small.add-attachment(
        title="Add attachment"
        @click="addAttachment"
        :disabled="!canAddAttachment")
        | Add attachment
      .compose-message-validation(v-if="attachmentError")
        div.svg-icon
          svg(viewBox="0 0 32 32" class="svgicon" aria-hidden="true" focusable="false")
            path(d="M9.79 1.27a15.87 15.87 0 0 1 12.42 0 15.75 15.75 0 0 1 8.52 8.52 15.87 15.87 0 0 1 0 12.42 15.75 15.75 0 0 1-8.52 8.52 15.87 15.87 0 0 1-12.42 0 15.75 15.75 0 0 1-8.52-8.52 15.87 15.87 0 0 1 0-12.42 15.75 15.75 0 0 1 8.52-8.52zM16 30a13.69 13.69 0 0 0 5.44-1.11 14.13 14.13 0 0 0 4.47-3 14 14 0 0 0 3-4.46 13.92 13.92 0 0 0 0-10.89 13.76 13.76 0 0 0-7.45-7.45 13.92 13.92 0 0 0-10.89 0 14 14 0 0 0-4.46 3 14.13 14.13 0 0 0-3 4.47 13.92 13.92 0 0 0 0 10.89 13.7 13.7 0 0 0 7.44 7.44A13.72 13.72 0 0 0 16 30zm6.22-17.5l-3.5 3.5 3.5 3.5-2.72 2.72-3.5-3.5-3.53 3.5-2.69-2.72 3.5-3.5-3.5-3.5 2.69-2.72 3.53 3.5 3.5-3.5z")
        span.validation-msg {{ attachmentValidationMessage }}
</template>
<script>
import CoachingMessageInternalLinkInput from '@/components/coaching/CoachingMessageInternalLinkInput.vue';
import validURL from 'valid-url';

export default {
  name: 'AttachmentInput',
  props: [],
  components: {
    CoachingMessageInternalLinkInput
  },
  data() {
    return {
      canAddAttachment: true,
      attachmentType: null,
      attachmentUrl: '',
      attachmentInputPlaceholder: '',
      attachmentError: false,
      attachmentValidationMessage: '',
      externalLinkTitle: '',
      showActivityToolTip: false
    };
  },
  methods: {
    toggleAttachment(type) {
      // Toggle off if user clicks same button twice
      if (this.attachmentType === type) {
        this.externalLinkTitle = '';
        this.attachmentType = null;
        this.attachmentUrl = '';

        return;
      }

      this.attachmentType = type;

      if (
        this.attachmentType === 'EXTERNAL_LINK' &&
        this.$refs.attachmentTitleInput
      ) {
        setTimeout(() => {
          this.$refs.attachmentTitleInput.focus();
        }, 200);
      } else if (
        this.attachmentType !== 'INTERNAL_LINK' &&
        this.$refs.attachmentInput
      ) {
        setTimeout(() => {
          this.$refs.attachmentInput.focus();
        }, 200);
      }
    },
    addAttachment() {
      // Correct EXTERNAL_LINK_PHONE to EXTERNAL_LINK
      const payloadAttachmentType =
        this.attachmentType === 'EXTERNAL_LINK_PHONE'
          ? 'EXTERNAL_LINK'
          : this.attachmentType;
      this.attachmentValidationMessage = '';

      if (!this.validateAttachment()) {
        // Show validation errors
        this.attachmentError = true;
      } else {
        // Add attachment
        this.attachmentError = false;

        let attachmentPayload = {
          type: payloadAttachmentType,
          content: this.attachmentUrl
        };

        if (this.attachmentType === 'EXTERNAL_LINK') {
          // Add title for EXTERNAL_LINK
          attachmentPayload.title = this.externalLinkTitle;
        } else if (this.attachmentType === 'EXTERNAL_LINK_PHONE') {
          // Add title and tel: for EXTERNAL_LINK_PHONE
          attachmentPayload.title = this.attachmentUrl;
          attachmentPayload.content = `tel:${attachmentPayload.content}`;
        }

        // Event attachment to parent
        this.$emit('add-attachment', attachmentPayload);

        // Close and reset message attachment
        this.toggleAttachment(this.attachmentType);
      }
    },
    setCanAddAttachment(value) {
      this.canAddAttachment = value;
    },
    addInternalLinkAttachment(internalLink) {
      this.attachmentUrl = internalLink;
      this.setCanAddAttachment(true);
    },
    validateAttachment() {
      const attachmentMaxLength = 1024;
      let isValid = true;

      // Validate that attachment not empty
      if (this.attachmentUrl.trim().length === 0) {
        this.attachmentValidationMessage = this.pluralizeValidationMessage(
          'Add an attachment'
        );
        isValid = false;
      }

      // Validate that attachment length is less than DB column length
      if (this.attachmentUrl.length > attachmentMaxLength) {
        this.attachmentValidationMessage = this.pluralizeValidationMessage(
          `Attachment URL length is longer than ${attachmentMaxLength} characters, consider using admin redirect or url shortener`
        );
        isValid = false;
      }

      // Validate EXTERNAL_LINK title is set
      if (
        this.attachmentType === 'EXTERNAL_LINK' &&
        this.externalLinkTitle.trim().length === 0
      ) {
        this.attachmentValidationMessage = this.pluralizeValidationMessage(
          'Attachment title cannot be empty for external link'
        );
        isValid = false;
      }

      // Validate that EXTERNAL_LINK urls are valid in structure
      if (
        this.attachmentType === 'EXTERNAL_LINK' &&
        !this.isValidURL(this.attachmentUrl)
      ) {
        this.attachmentValidationMessage = this.pluralizeValidationMessage(
          'Attachment URL is invalid'
        );
        isValid = false;
      }

      if (
        this.attachmentType === 'EXTERNAL_LINK_PHONE' &&
        this.attachmentUrl.length < 10
      ) {
        this.attachmentValidationMessage = this.pluralizeValidationMessage(
          'Phone number must be at least 10 numbers'
        );
        isValid = false;
      }

      if (
        this.attachmentType === 'EXTERNAL_LINK_PHONE' &&
        !this.isNumeric(this.attachmentUrl)
      ) {
        this.attachmentValidationMessage = this.pluralizeValidationMessage(
          'Phone number must be numeric'
        );
        isValid = false;
      }

      return isValid;
    },
    pluralizeValidationMessage(message) {
      let newMessage = '';
      if (this.attachmentValidationMessage.length > 0) {
        // Handle multiple validation messages
        newMessage = `${this.attachmentValidationMessage},
          and the ${this.lowerCaseFirstStringCharacter(message)}`;
      } else {
        newMessage = message;
      }

      return newMessage;
    },
    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    setShowActivityToolTip(shown) {
      this.showActivityToolTip = shown;
    },
    toggleActivityToolTip() {
      this.showActivityToolTip = !this.showActivityToolTip;
    },
    lowerCaseFirstStringCharacter(string) {
      return string.charAt(0).toLowerCase() + string.slice(1);
    },
    isValidURL(url) {
      return validURL.isWebUri(url);
    }
  },
  watch: {
    attachmentType(newType) {
      let humanReadableType = '';

      if (newType === 'ACTIVITY') {
        humanReadableType = 'Enter an activity identifier';
      } else if (newType === 'INTERNAL_LINK') {
        humanReadableType = 'Enter an internal URL';
      } else if (newType === 'EXTERNAL_LINK') {
        humanReadableType = 'Enter an external URL';
      } else if (newType === 'EXTERNAL_LINK_PHONE') {
        humanReadableType = 'Enter a phone number';
      }

      this.attachmentInputPlaceholder = humanReadableType;
    }
  }
};
</script>
<style lang="scss" scoped>
section.attachment-input {
  .button-group {
    margin: $small-spacing auto $xs-spacing;
  }

  button.tag {
    background-image: linear-gradient(to bottom, #fff 70%, $md-grey-100);
    position: relative;
    margin: 0 4px $xs-spacing 0;
    padding: 4px 8px;
    padding-left: 24px;
    border-radius: 1em;
    font-family: $sans-font-family;
    font-size: $ms-down1;
    text-transform: uppercase;
    color: $grey;
    cursor: hand;
    border: 1px solid $md-grey-200;
    transition: all 0.25s ease;
    text-align: left;

    &:before {
      content: '\2795';
      display: block;
      position: absolute;
      left: 6px;
      top: 5px;
      font-size: 12px;
    }
    &:active,
    &.active {
      outline: none;
      opacity: 0.6;
      box-shadow: 0 0 0 rgba(#fff, 0);
      transform: scale(0.98);
    }
    &:hover,
    &:focus {
      border-color: $action-color;
      color: $action-color;
      background: #fff;
      @include drop-shadow;
      outline: none;
    }
  }

  .compose-message-add-link {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: $small-spacing;
    flex-wrap: wrap;

    input.title {
      flex-basis: 100%;
      margin-bottom: 10px;
    }
    input.link {
      flex-basis: calc(100% - 25px);
      background: #fff;
      margin-right: 8px;

      &:active,
      &:focus {
        outline: 1px solid $action-color;
        box-shadow: 0 0 0 rgba(#fff, 0);
      }
    }
    button.cancel {
      color: $error-color;
      @include zero;
      cursor: pointer;
      overflow: hidden;

      &:active,
      &:focus {
        outline: none;
      }
      .close-icon {
        display: block;
        position: relative;
        transform: rotate(45deg);
      }
    }
    .tooltip-wrapper {
      position: relative;
      width: 100%;
      margin: $xs-spacing 0;
      font-size: 0.75rem;

      .activity-tooltip-content {
        top: 24px;
        right: auto;
        bottom: auto;
        left: 0px;
        width: 100%;
        word-break: break-word;

        ul {
          margin: 0;
          li {
            &:last-child {
              margin-bottom: 0;
            }
            margin-bottom: $small-spacing;
          }
        }
      }
    }
  }

  .add-attachment {
    display: inline-block;
    width: auto;
    margin-bottom: 20px;
  }

  .compose-message-validation {
    margin-bottom: 16px;
    font-size: 11px;
    font-weight: 600;
    color: $md-red-700;

    @include media-query-bp($bp5) {
      font-size: 14px;
    }

    div.svg-icon {
      display: inline;
      position: relative;
      top: 1px;

      svg {
        height: 17px;
        width: 17px;
      }
    }
    .validation-msg {
      line-height: 1.33;
      margin-left: 4px;
    }
  }

  // Transition
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.34s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
